<template>
    <section class="height100vh"  style="padding-top:0;height: calc(100vh - 68px);">
        <div class="wrap">
            <div class="new_content_box1">
                <h3 class="title" style="margin-top:0">
                    <span>선택한 모델</span>
                    <router-link :to="selectVehiclePath">변경</router-link>
                </h3>
                <!--  :style="`background-image:url(${bookingWrite.modelUrl});`" -->
                <div class="default_box pick_car">
                    <img :src="bookingWrite.modelUrl" height="80">
                    <dl>
                        <dt>
                            <img :src="bookingWrite.brandUrl" width="20">
                            {{ bookingWrite.brandName }}
                        </dt>
                        <dd>
                            {{ bookingWrite.modelName }} / {{ bookingWrite.trimName }}
                        </dd>
                    </dl>
                    
                </div>
            </div>

            <div class="new_content_box2">
                <h3 class="title">
                    <span>현재 위치</span>
                    <!-- 팝업으로 띄워짐 -->
                    <a @click="kakaoAddr(kakaoAddrCallback)">변경</a> 
                    <!-- 페이지 이동 -->
                    <!-- <a @click="$router.replace(kakaoJusoPath)">변경</a> -->
                </h3>
                <div class="default_box">
                    <p class="new_address">{{ bookingWrite.addr }}</p>
                </div>
                <p class="new_address_info">이 위치를 기준으로 컨설턴트와 전시장 정보를 검색합니다.</p>
            </div>
           
           <div class="new_content_box1">
                <h3 class="title"><span>예약 목적</span></h3>
                <ul class="reservation_ul">
                    <li v-for="bookingType in BOOKING_TYPE" :key="`booking-purpose-item-${bookingType.id}`">
                        <div class="chk_box">
                            <input type="radio" class="chk_box" :id="`purpose-${bookingType.id}`"
                                :name="`purpose-${bookingType.id}`" v-model="bookingWrite.type" :value="bookingType.id">
                            <label :for="`purpose-${bookingType.id}`"></label>
                            <label :for="`purpose-${bookingType.id}`">{{bookingType.content}}</label>
                        </div>
                    </li>
                </ul>
           </div>
            
        </div>
        <button class="default_fixed_btn" @click="next()">다음</button>
    </section>
</template>
<script>

import { mapState} from 'vuex';
import { KakaoApiMixin } from '../../mixins/KakaoApiMixin.js';

export default {
    name: 'BookingInputBasic',
    mixins:[
        KakaoApiMixin
    ],

    data() {
        return {}
    },

    computed: {
        ...mapState({
            currentLocationLat: state => state.currentLocationLat,
            currentLocationHar: state => state.currentLocationHar,

            bookingWrite: state => state.booking.itemWrite,
            BOOKING_TYPE: state => state.codeDictionary.items.BOOKING_TYPE
        }),
        bookingId() {
            return Number(this.$route.params.bookingId);
        },
        routerPath() {
            let path = '/booking/inputDetail';
            return (this.bookingId) ? `${path}/${this.bookingId}` : path;
        },
        kakaoJusoPath(){
            let path = '/booking/kakaoJuso';
            return (this.bookingId) ? `${path}/${this.bookingId}` : path;
        },
        selectVehiclePath() {
            // let path = `/booking/selectVehicle/${this.trimItem.brandId}`;
            let path = `/booking/selectVehicle/${this.bookingWrite.brandId}`;
            return (this.bookingId) ? `${path}/${this.bookingId}` : path;
        }
    },

    async created() {
        if(!this.bookingId)
            this.bookingWrite.type = this.BOOKING_TYPE.CONSULTING.id;

        if(!this.bookingWrite.getLocation) 
            await this.setBookingLatHarAndAddr()
        
        this.$store.commit('SHOW_ONLOAD');
    },

    methods: {
        next()
        {
            try {
                if (!this.bookingWrite.trimId) throw '모델을 선택해주세요.';
                if (!this.bookingWrite.type) throw '예약 목적을 선택해주세요.';
                this.$router.push(this.routerPath);
            } catch (e) {
                this.$store.commit('OPEN_MODAL', {
                    content: e,
                    btnOne: '확인',
                })
            }
        },

        async setBookingLatHarAndAddr() {
            console.log('setBookingLatHarAndAddr')
            var geocoder = new window.kakao.maps.services.Geocoder();
            var lat = this.currentLocationLat;
            var lng = this.currentLocationHar;
            var self = this;

            function searchDetailAddrFromCoords(lng,lat, callback) {
                // 좌표로 법정동 상세 주소 정보를 요청합니다
                geocoder.coord2Address(lng, lat, callback);
            }

            await searchDetailAddrFromCoords(lng, lat, function (result) {  
                let addressName = result[0].address.address_name;
                self.bookingWrite.addr = addressName;
                self.bookingWrite.lat = self.currentLocationLat
                self.bookingWrite.har = self.currentLocationHar

                console.log('searchDetailAddrFromCoords', addressName, lng, lat)
                self.$store.commit('SHOW_ONLOAD');
            })
            
            this.$store.commit('SHOW_ONLOAD');
        },

        kakaoAddrCallback(data) {
            let addr = data.addr;
            this.bookingWrite.getLocation = true;
            this.bookingWrite.addr = addr;
            this.kakaoCoords(addr, this.kakaoCoordsCallback)
        },

        kakaoCoordsCallback(data) {
            this.bookingWrite.lat = data.lat;
            this.bookingWrite.har = data.har;
        }

    },
}
</script>
1
<style lang="scss" scoped>
</style>